import React, { Component } from 'react';
import '../../components/Form/form.scss';
import Button from "../../components/Form/Button/Button";
import TextInput from "../../components/Form/TextInput/TextInput";
import { emailRegEx } from '../../utils/utils';
import text from '../../utils/text';

interface Props {
    email?: string;
    error: boolean;
    errorMessage?: string;
    handleSubmit: (value: any) => void;
    submitText: string;
    autofocus: boolean;
}
interface State {
    email?: string;
    error: boolean;
    submitDisabled: boolean;
    alreadyClicked: boolean;
}

class EmailForm extends Component<Props, State> {

    state: State = { email: '', error: false, submitDisabled: false, alreadyClicked: false };

    componentDidMount() {
        const {email, error} = this.props;
        this.setState({ email, error });
    }
    emailHasValidFormat(email?: string) {
       return email && emailRegEx.test(email);
    }
    handleChange(email: string) {
        this.setState({ email: email.trim() })
        if (this.state.alreadyClicked) {
            this.setState({ error: !this.emailHasValidFormat(this.state.email) });
        }
    }
    handleSubmit() {
        this.setState({alreadyClicked: true});
        if (this.emailHasValidFormat(this.state.email)){
            this.props.handleSubmit(this.state.email);
        } else {
            this.setState({error: true});
        }
    }

    render() {
        return (
            <form onSubmit={() => this.handleSubmit()} role='email'>
                <TextInput
                    onChange={(email: string) => this.handleChange(email)}
                    type="email"
                    label="Email professionnel"
                    value={this.state.email || ''}
                    error={this.state.error}
                    errorMessage={text.invalid_mail}
                    autofocus={this.props.autofocus}
                    mandatory={true}
                    id='email'
                />
                {this.state.error && <div className="errorMessageContainer"><span>{this.props.errorMessage}</span></div>}
                <Button
                    label={this.props.submitText}
                    onClick={() => this.handleSubmit()}
                />
            </form>
        );
    }
}
export default EmailForm;
